import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import ApiOptionsConfig from '../api-options.config';
import { ApiBaseService } from '../api-base.service';

const BASE_URL = '/employee-specialisations';

@Injectable({
  providedIn: 'root'
})
export class SpecialisationsService extends ApiBaseService {  

  list(options?: ApiOptionsConfig): Observable<any> {
   return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  create(data: any): Observable<any> {
   return this.POST(this.getUrl(BASE_URL), data);
  }

  detail(emploteeSpecialisationId: number, options?: ApiOptionsConfig): Observable<any> {
   return this.GET(this.getUrl(`${BASE_URL}/${emploteeSpecialisationId}`), options?.params);
  }

  update(emploteeSpecialisationId: number, data: any): Observable<any> {
   return this.PUT(this.getUrl(`${BASE_URL}/${emploteeSpecialisationId}`), data);
  }

  delete(emploteeSpecialisationId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${emploteeSpecialisationId}`));
  }
}